import "./namespace.js";
import.meta.glob("./templates/**/*.{js,hbs,jst.ejs}", { eager: true });
import "./helpers.js";
import "./search.js";
import "./templates.js";
import "./models.js";
import "./tool.js";
import "./drag.js";
import "./sidebar.js";
import "./modal.js";
import "./dialog.js";
import "./link_dialog.js";
import "./image_dialog.js";
import "./video_dialog.js";
import "./modals/slide_editor.js";
import "./modals/icon_editor.js";
import "./table_builder_dialog.js";
import "./shared_info_dialog.js";
import "./call_tracking_manager.js";
import "./wysiwyg_dialog.js";
import "./wysiwyg/namespace.js";
import "./wysiwyg/blots.js";
import "./wysiwyg/modules/index.js";
import "./wysiwyg/tooltips.js";
import.meta.glob("./tools/**/*.{js,hbs,jst.ejs}", { eager: true });

(function (
  Tool,
  Sidebar,
  Event,
  deepCopy,
  assert,
  numColumns,
  Section,
  Component,
  Page,
  SharedComponent,
  FormComponent,
  Row,
) {
  "use strict";

  /**
   * @module page-builder
   * @type {HTMLElement}
   */

  var PageBuilder = Sparkle.PageBuilder;

  function load(componentsJSON, page) {
    var config = page.config;
    var element = page.element;
    var data = componentsJSON.data;
    var structure = componentsJSON.structure;

    Component.uncustomized = data.uncustomized;
    Component.rendered = data.rendered;
    Component.metadata = componentsJSON.metadata;

    // load up all the components

    _.keys(structure.rendered).forEach(function (sectionName) {
      var sectionElement = jQuery(page.element).find('[data-component-section="' + sectionName + '"]')[0];
      // we currently get data on the page saying there's a section but there's no corresponding
      // element. Need to ignore that data here.
      if (sectionElement) {
        var componentsPerRow = Number(sectionElement.dataset.componentsPerRow);
        var section = Section(sectionName, sectionElement, componentsPerRow);
        var components = [];
        var componentKeys = structure.rendered[sectionName];

        componentKeys.forEach(function (key) {
          var componentElement = jQuery(element).find("#component_" + key)[0],
            component = Component.create(data.raw[key], config, componentElement);

          components.push(component);
        });

        section.add(components);
      }
    });
  }

  /**
   * Initialize the data for page builder.
   * @param {HTMLElement} element - The body element of the page being edited
   * @param {object} data - component data for the page
   * @param {object} config - component metadata and templates
   */
  function initialize(componentsJSON, callTrackingData, config, element, sideElement) {
    var page = Page(element, config),
      sidebar = Sidebar(page, sideElement);

    PageBuilder.Templates.loadTemplates(config);
    load(componentsJSON, page);

    if (callTrackingData) {
      PageBuilder.CallTrackingManager.initialize(callTrackingData);
    }

    function repositionRows() {
      Row.rows.forEach(function (row) {
        row.positionElement();
      });
    }
    Event.on("pb:sidebar:show", repositionRows);
    Event.on("pb:sidebar:hide", repositionRows);
    Event.on("pb:sidebar:unload", sidebar.unload.bind(sidebar));
    Event.on("pb:sidebar:editComponent", sidebar.editComponent.bind(sidebar));
    Event.on("pb:section:remove", function (component) {
      var page = sidebar.page;
      if (page.component === component) {
        sidebar.showDefaultView();
      }
    });
    Event.on("pb:section:completeremove", function (component) {
      if (component.replacement) {
        Sparkle.PageBuilder.Page.saveAndReload();
      }
    });

    return sidebar;
  }

  function reinitialize(componentsJSON, config, element, sidebar) {
    Row.clear();
    // Drop zones use Section.createRows → Row.rows. Orphan Section objects from the
    // previous iframe document must not survive a soft-reload or row ids / Row.rows
    // indices drift and drag-and-drop stops recognizing targets (e.g. after leaving
    // the Content tab and returning once the preview iframe has reloaded).
    Section.instances = {};
    var page = Page(element, config);
    load(componentsJSON, page);
    sidebar.setPage(page);
  }

  //export
  _.extend(Sparkle.PageBuilder, {
    initialize: initialize,
    load: load,
    reinitialize: reinitialize,
  });
})(
  Sparkle.PageBuilder.Tool,
  Sparkle.PageBuilder.Sidebar,
  Sparkle.PageBuilder.Helpers.Event,
  Sparkle.PageBuilder.Helpers.deepCopy,
  Sparkle.PageBuilder.Helpers.assert,
  Sparkle.PageBuilder.Helpers.numColumns,
  Sparkle.PageBuilder.Section,
  Sparkle.PageBuilder.Component,
  Sparkle.PageBuilder.Page,
  Sparkle.PageBuilder.SharedComponent,
  Sparkle.PageBuilder.FormComponent,
  Sparkle.PageBuilder.Row,
);
